import { render } from "./AdvertisingMix.vue?vue&type=template&id=593bb58a&scoped=true"
import script from "./AdvertisingMix.vue?vue&type=script&lang=js"
export * from "./AdvertisingMix.vue?vue&type=script&lang=js"

import "./AdvertisingMix.vue?vue&type=style&index=0&id=593bb58a&lang=scss&scoped=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-593bb58a"]])

export default __exports__